import { RetailRefundReason } from '@galaxy/billing';
import { TranslateService } from '@ngx-translate/core';

export function refundReasonToDisplayReason(translateService: TranslateService, reason: RetailRefundReason): string {
  switch (reason) {
    case RetailRefundReason.Unset:
      return translateService.instant('REFUND_REASON.UNSET');
    case RetailRefundReason.Duplicate:
      return translateService.instant('REFUND_REASON.DUPLICATE');
    case RetailRefundReason.Fraudulent:
      return translateService.instant('REFUND_REASON.FRAUDULENT');
    case RetailRefundReason.RequestedByCustomer:
      return translateService.instant('REFUND_REASON.REQUESTED_BY_CUSTOMER');
    default:
      return translateService.instant('REFUND_REASON.UNKNOWN');
  }
}
